export type ConfidenceStatusTone =
  'confident' | 'needsReview' | 'lowConfidence' | 'missingData';

export const CONFIDENCE_STATUS_COLORS: Record<
  ConfidenceStatusTone,
  { main: string; background: string; text: string }
> = {
  confident: {
    main: '#2e7d32',
    background: '#f0fdf4',
    text: '#2e7d32'
  },
  needsReview: {
    main: '#eab308',
    background: '#fefce8',
    text: '#a16207'
  },
  lowConfidence: {
    main: '#ed6c02',
    background: '#fff7ed',
    text: '#c2410c'
  },
  missingData: {
    main: '#dc2626',
    background: '#fef2f2',
    text: '#dc2626'
  }
};

export const getConfidenceFieldSx = (
  baseSx: object,
  tone: Extract<ConfidenceStatusTone, 'needsReview' | 'lowConfidence'>
): object => {
  const { main, text } = CONFIDENCE_STATUS_COLORS[tone];

  return {
    ...baseSx,
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: main
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: main
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: main
    },
    '& .MuiInputLabel-root': {
      color: main
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: main
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: main
    },
    '& .MuiFormHelperText-root': {
      color: text
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: text
    }
  };
};
